<template>
  <form class="search-form" :class="{ mobile: whiteOnMobile }" @submit.prevent="$emit('submit')">
    <input
      class="search-input"
      :value="modelValue"
      type="text"
      :placeholder="placeholder"
      @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
    />
  </form>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DashboardSearchBox',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Pesquisar relatorios, atividades, datas...'
    },
    whiteOnMobile: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'submit']
})
</script>

<style scoped lang="scss">
.search-form {
  width: 100%;
  display: block;
  align-items: stretch;
}

.search-input {
  width: 100%;
  box-sizing: border-box;
  height: 40px;
  border: 1px solid var(--system-search-border, transparent);
  border-radius: 6px 6px 6px 6px;
  padding: 0 12px;
  background: var(--system-search-bg, #f3ede3);
  color: #2c2b27;
  outline: none;
}

.search-form.mobile .search-input {
  background: #fff;
}
</style>
